import { Bar, BarChart, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import type { PercentageDatum } from '../RenterDataReport.utils';
import { roundUp } from '../../../../../utils/roundUp';
import { formatNumber } from '../../../../../utils';

const PRIMARY_BAR_COLOR = '#891EFA';

type VerticalBarChartProps = {
  data: Array<PercentageDatum>;
  height?: number;
};

export const VerticalBarChart = ({ data, height = 240 }: VerticalBarChartProps) => {
  const maxValue = Math.max(...data.map((item) => item.value), 1);
  const scale = Math.ceil(maxValue / 10) * 10 || 10;
  const threshold = (scale * 15) / 100;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderCustomLabel = (props: any) => {
    // eslint-disable-next-line react/prop-types
    const { x, y, width, height: barHeight, value } = props;
    const isSmall = value < threshold;

    return (
      <text
        x={x + width / 2}
        y={isSmall ? y - 8 : y + barHeight / 2}
        fill={isSmall ? 'black' : 'white'}
        textAnchor="middle"
        dominantBaseline={isSmall ? 'auto' : 'middle'}
        style={{ fontSize: 12, fontWeight: 600 }}
      >
        {roundUp(Number(value), 1)}%
      </text>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 20, right: 10, bottom: 30, left: 10 }}>
        <XAxis
          dataKey="label"
          tickLine={false}
          axisLine={{ stroke: '#E5E7EB', strokeWidth: 1 }}
          tick={{ fontSize: 12, fill: '#6B7280' }}
          interval={0}
          tickFormatter={(value) => (isNaN(Number(value)) ? value : formatNumber(roundUp(Number(value), 1)))}
        />
        <YAxis
          hide
          domain={[0, maxValue]}
          tickFormatter={(value) => (isNaN(Number(value)) ? value : formatNumber(roundUp(Number(value), 1)))}
        />
        <Bar dataKey="value" fill={PRIMARY_BAR_COLOR} radius={[4, 4, 0, 0]} maxBarSize={100} isAnimationActive={false}>
          <LabelList dataKey="value" content={renderCustomLabel} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
